import React from 'react'
import styled from 'styled-components'

export default function NoModels() {
    return (
        <Container>
            <i class="far fa-empty-set"></i>
            <span>No Database</span>
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    height: 70%;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    span {
        font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 16px;
        text-align: center;

        color: #364159;
    }

    i {
        font-family: Font Awesome 5 Pro;
        font-style: normal;
        font-weight: normal;
        font-size: 30px;
        line-height: 40px;

        text-align: center;

        color: #bac0cb;
    }
`
